import { render, staticRenderFns } from "./DunningAnalytics.vue?vue&type=template&id=06e8baf5&"
import script from "./DunningAnalytics.vue?vue&type=script&lang=ts&"
export * from "./DunningAnalytics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports